$(window).on("load", function () {
  let selects = $(".js-select")

  if (selects) {
    selects.each(function () {
      const that = $(this)
      const defOption = $('<option value="Country" data-provinces="[]" selected disabled></option>')

      const ph = $('<div class="placeholder-select">Country <span>*</span></div>')

      $(this).find("option:first-child").remove()
      $(this).prepend(ph)
      $(this).find("select").prepend(defOption)

      $(this)
        .find("select")
        .change(function (e) {
          $(this).css("color", "rgb(var(--color-foreground), 1)")
          that.find(".placeholder-select").remove()
        })
    })
  }

  //   ;(function () {
  let registrationForm = $("#create_customer").parsley({
    errorClass: "--state-error",
  })

  registrationForm.on("form:submit", function () {
    let cleared = $(".parsley-error").length === 0
    let form = $("#create_customer")
    let registrationLoader = document.querySelector(".registration-loader")

    console.log("cdebug", cleared)

    if (cleared) {
      registrationLoader && registrationLoader.classList.add("--active")
      localStorage.setItem("afterRegister", true)
      form.submit()
    }
  })

  var passwordVisibilityToggle = document.querySelectorAll(".password-visibility-toggle")
  console.log("cdebug", passwordVisibilityToggle)
  passwordVisibilityToggle = Array.from(passwordVisibilityToggle)

  console.log("cdebug", passwordVisibilityToggle)

  passwordVisibilityToggle.forEach(element => {
    element.addEventListener("click", function (e) {
      const siblingInput = e.target.closest(".twc-material-outlined").querySelector("input")

      if (siblingInput && siblingInput.type == "password") {
        siblingInput.type = "text"
      } else {
        siblingInput.type = "password"
      }
    })
  })
  //   })()
})
